import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { loadStripe } from '@stripe/stripe-js';
import { StripeService } from 'src/app/core/stripe.service';

@Component({
  selector: 'app-get-premium',
  templateUrl: './get-premium.component.html',
  styleUrls: ['./get-premium.component.scss'],
  standalone: false
})
export class GetPremiumComponent {

  private stripe: any;
  private STRIPE_KEY: string = 'pk_live_51Qa1aDCidLpuUy0g3NvVsyGbHW678LzId9h553j3SmoOsZHGrviw88SVwoZaZluAUPf9o55wJlO8a2IqFeH67CkZ00IfAbH9F2'; // live key
  // private STRIPE_KEY: string = 'pk_test_51Qa1aDCidLpuUy0g0AHIAkF8PQkTrLgHEYUKtFOKC95Uqj8R88u2tEiZ83KdbZ5kFBCPM0mYLYhHdfcWZqWWu0M900XLN7B4KO'; // test key

  paymentSuccess: boolean = false;
  paymentFailed: boolean = false;
  
  benefits: any[] = [
    {
      icon: 'cards',
      title: 'Keine Limits beim Erstellen von Karteikarten mit KI',
      description: 'Keine Limits beim Hochladen von Dateien. Lasse dir Karteikarten blitzschnell aus deinen Dateien mit mehr als 20 Seiten erstellen.'
    },
    {
      icon: 'brain',
      title: 'Zwei zusätzliche Lernmodi für noch smarteres Wiederholen',
      description: 'Wiederhole Karteikarten mit dem Text- oder Audio-Modus: Gib deine Antwort per Tastatur ein oder sprich sie ein. Die KI bewertet automatisch, gibt Feedback und plant den nächsten Wiederholzeitpunkt.'
    },
    {
      icon: 'click',
      title: 'Ausführliche Erklärungen mit einem Klick',
      description: 'Weißt du nicht mehr genau, worum es bei einer Karteikarte ging? Mit einem Klick zeigt dir die KI eine verständliche, ausführliche Erklärung – in allen drei Lernmodi.'
    },
    {
      icon: 'file-ai',
      title: 'Teste dein Wissen mit KI-Probeklausuren',
      description: 'Lass dir auf Knopfdruck Probeklausuren aus deinen Lernsets erstellen. Nach dem Test bekommst du eine Note, Feedback und Verbesserungsvorschläge von der KI.'
    },
    {
      icon: 'confetti',
      title: '+2 weitere Vorteile'
    }
    /*{
      icon: 'sparkles',
      title: 'Keine Lernlücken mehr',
      description: 'Sparkly erkennt automatisch Lernlücken in deinen Lernsets und schlägt dir basierend darauf passende Lernkarten vor.'
    },*/
    /*{
      title: 'Smarte Lernmodi',
      description: 'Schalte Multiple Choice und Lernen mit dem Sparkly-KI-Trainer frei und lerne noch effizienter.'
    },
    {
      title: 'Klausuren simulieren',
      description: 'Teste dein Wissen mit unseren KI-Probeklausuren und bereite dich perfekt auf anstehende Prüfungen vor.'
    },*/
  ];

  additionalBenefits: any[] = [
    {
      icon: 'input-spark',
      title: 'Rückseiten automatisch erstellen – schnell & präzise',
      description: 'Gib nur die Vorderseite ein – die KI erstellt sofort eine passende Rückseite (Definition, Beispiel oder Lösungsschritte). So erstellst du Karteikarten doppelt so schnell.'
    },
    {
      icon: 'messages',
      title: 'Chatte mit der KI während du Lernkarten erstellst',
      description: 'Unsicher bei einer Definition? Frag einfach die KI im Chat – sie hilft dir direkt beim Erstellen deiner Karteikarten weiter.'
    },
  ];

  showAllBenefits: boolean = false;
  paymentInterval: 'monthly' | 'yearly' = 'yearly';

  constructor(
    private router: Router,
    private stripeService: StripeService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.paymentSuccess = Boolean(this.route.snapshot.queryParamMap.get('payment-success'));
    this.paymentFailed = Boolean(this.route.snapshot.queryParamMap.get('payment-error'));

    loadStripe(this.STRIPE_KEY).then((stripe) => {
      this.stripe = stripe;
    });
  }

  handlePayment() {
    this.stripeService.createCheckoutSession(this.paymentInterval).subscribe(
      (response) => {
        this.stripe.redirectToCheckout({ sessionId: response.id }).then((result: any) => {
          if (result.error) {
            console.log(result.error.message);
          }
        });
      },
      (error) => {
        console.error('Error creating checkout session:', error);
      }
    );
  }

  navigateToDashboard() {
    this.router.navigate(['home']);
  }

  showAdditionalBenefits() {
    this.showAllBenefits = true;
    this.benefits.pop();
    this.benefits.push(...this.additionalBenefits);
  }
}
